module.exports = __webpack_public_path__ + "static/media/Pulmonology-Condition Intake-1@3x.8bfdb5d3.png";